




import { Component, Vue, Watch } from 'vue-property-decorator';

import CustomerImportService from '@/api/CustomerImportService';
import eventBus from '@/utils/eventBus';
import flagKeys from '@/constants/flagKeys';
import { ECustomerImportProgressStatus } from '@/models/customer-import';
import { customerImportValidator } from '@/router/validators/navbar';

let timer: NodeJS.Timeout;
const POLLING_TIME = 10000; // 10s

@Component({})
export default class CustomersImportStatus extends Vue {
  customerImportService = new CustomerImportService();
  successfulRequests = 0;
  stopPoolling = false;

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get customerImportIsActivated() {
    return (
      this.flags.includes(flagKeys.customerImport) &&
      customerImportValidator().isValid
    );
  }

  get customerImportRoute() {
    return '/customer-import';
  }

  get isCustomerImportRoute() {
    return window.location.pathname === this.customerImportRoute;
  }

  @Watch('$route')
  onRouteChange(to: { path: string; name: string }) {
    this.stopCheckingCustomerImportStatus();

    if (to.path === this.customerImportRoute) {
      this.stopCheckingCustomerImportStatus();

      return;
    }

    if (this.customerImportIsActivated) {
      this.successfulRequests = 0;
      this.checkCustomerImportStatus();
    }
  }

  async checkCustomerImportStatus() {
    if (
      this.stopPoolling ||
      !this.customerImportIsActivated ||
      this.isCustomerImportRoute ||
      !this.currentProvider
    ) {
      this.stopCheckingCustomerImportStatus();

      return;
    }

    let scopedStatus = '';

    try {
      const { data } = await this.customerImportService.getImportStatus(
        this.currentProvider.name
      );

      this.successfulRequests++;

      const { success, status, message, clickedGetStarted = false } = data;

      scopedStatus = status;

      this.stopPoolling = !clickedGetStarted;

      if (!clickedGetStarted || !success) {
        this.stopCheckingCustomerImportStatus();

        return;
      }

      if (scopedStatus === ECustomerImportProgressStatus.DONE) {
        this.stopCheckingCustomerImportStatus();

        if (this.successfulRequests > 1) {
          this.$notification(message);
        }

        return;
      }
    } finally {
      if (scopedStatus !== ECustomerImportProgressStatus.DONE) {
        timer = setTimeout(this.checkCustomerImportStatus, POLLING_TIME);
      }
    }
  }

  stopCheckingCustomerImportStatus() {
    if (timer) clearTimeout(timer);
  }

  mounted() {
    eventBus.$on('checkCustomerImportStatus', this.checkCustomerImportStatus);
    eventBus.$on(
      'stopCheckingCustomerImportStatus',
      this.stopCheckingCustomerImportStatus
    );
  }

  beforeDestroy() {
    this.stopCheckingCustomerImportStatus();

    eventBus.$off('checkCustomerImportStatus', this.checkCustomerImportStatus);
    eventBus.$off(
      'stopCheckingCustomerImportStatus',
      this.stopCheckingCustomerImportStatus
    );
  }
}
